import Es6PromisePool from 'es6-promise-pool';

export async function allWithMax(promiseCreators = [], max = 10) {
    const producer = () => {
        if (!promiseCreators || promiseCreators.length === 0) {
            return null;
        }

        return promiseCreators.shift()();
    };
    return new PromisePool(producer, max)
        .start();
}

// took from https://github.com/timdp/es6-promise-pool/issues/51
class PromisePool extends Es6PromisePool {

    constructor(source, concurrency, options) {
        super(source, concurrency, options);
        this.resolves = [];
    }

    start() {
        this.addEventListener('fulfilled', (event) => {
            this.resolves.push(event.data.result);
        });

        return super.start().then(() => {
            return Promise.resolve(this.resolves);
        });
    }
}



// WEBPACK FOOTER //
// ./src/utils/promise-utils.js